<template>
  <div class="list-table">
    <v-container>
      <v-layout row>
        <v-flex lg12>
          <v-card>
            <v-toolbar color="#bd614d" dark>
              <v-toolbar-side-icon></v-toolbar-side-icon>
              <v-toolbar-title>Notificaciones</v-toolbar-title>
            </v-toolbar>

            <v-list two-line v-if="feeds.length > 0">
              <template v-for="(item, index) in feeds">
                <v-list-tile :key="item.title" avatar ripple>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      item.userComment
                    }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary"
                      >FACTURA #{{ item.invoiceId }}</v-list-tile-sub-title
                    >
                    <v-list-tile-sub-title>{{
                      item.action
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-list-tile-action-text>
                      {{ item.dateComment }}
                    </v-list-tile-action-text>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider
                  :key="index"
                  v-if="index + 1 < feeds.length"
                ></v-divider>
              </template>
            </v-list>

            <v-list v-else>
              <template>
                <v-list-tile :key="1" avatar ripple>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Bienvenido al Sistema de Notificaciones de TRANSIT
                    </v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary"
                      >Aun no tiene notificaciones.</v-list-tile-sub-title
                    >
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-list-tile-action-text>Ahora</v-list-tile-action-text>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      feeds: state => state.feeds.all,
    }),
  },
  created() {
    this.$store.dispatch('feeds/getAll').then(response => {
      console.log(response)
    })
  },
}
</script>
